import Navbar from "./Navbar";
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Home from "./Home";
import Footer from "./Footer";
import Services from "./Services";
import Aboutus from "./Aboutus";
import Snowfall from 'react-snowfall';

function App() {
  return (
    <Router> 
{/*       
      <Snowfall 
        style={{
          position: 'fixed',
          width: '100vw',
          height: '100vh',
          pointerEvents: 'none', 
          zIndex: 9999, 
          filter: 'blur(1.5px)', 
        }}
        
        snowflakeCount={300} 
        speed={[1.0, 5.0]} 
        wind={[-1.0, 3.0]} 
        radius={[0.5, 3.0]} 
      />
       */}
      <Navbar />
      
      <Routes>
        <Route path="/" element={<Services />} />
        <Route path="/products" element={<Home />} />
        <Route path="/about" element={<Aboutus />} />
      </Routes>
      
      <Footer />
      
    </Router>
  );
}

export default App;